import Icon from '../components/Icon.vue'

Icon.register({
  dumpster: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 160C570.4 160 578 150.2 575.5 140.1L551.5 44.1C549.7 37 543.3 32 536 32H437.1L462.7 160H560zM272 32H171.5L145.9 160H272V32zM404.5 32H304V160H430.1L404.5 32zM16 160H113.3L138.9 32H40C32.7 32 26.3 37 24.5 44.1L0.5 140.1C-2 150.2 5.6 160 16 160zM560 224H540L544 192H32L36 224H16C7.2 224 0 231.2 0 240V272C0 280.8 7.2 288 16 288H44L64 448V464C64 472.8 71.2 480 80 480H112C120.8 480 128 472.8 128 464V448H448V464C448 472.8 455.2 480 464 480H496C504.8 480 512 472.8 512 464V448L532 288H560C568.8 288 576 280.8 576 272V240C576 231.2 568.8 224 560 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dumpster.js
// module id = XNJj
// module chunks = 144